import React from 'react';
import { useTheme } from 'styled-components';

import { PrimaryButton } from '@longline/aqua-ui/controls/PrimaryButton';
import { SVG } from '@longline/aqua-ui/svg';

interface IPaneSubmitButtonProps {
  onClick: () => void;
  disabled?: boolean;
  working?: boolean;
}

const PaneSubmitButton = (props: IPaneSubmitButtonProps) => {
  const theme = useTheme();
  return (
    <PrimaryButton 
      disabled={props.working || props.disabled} 
      onClick={props.onClick} 
      icon={props.working ? { url: SVG.Icons.CircleNotch, animated: true } : undefined}>
        {props.working ? 'SAVING' : 'SAVE'}
      </PrimaryButton>
  )
}

export { PaneSubmitButton }
